import {Injectable} from "@angular/core";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";

@Injectable()
export class ErrorHandlingHttpInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {

        return event;
      }),
      catchError(this.handleError.bind(this, request)));
  }


  private handleError(request: HttpRequest<any>, error: HttpErrorResponse) {
    let url = error.url;
    if (request.url !== request.urlWithParams) {
      url = url.replace(request.url, request.urlWithParams);
    }
    if (request.body !== undefined) {
      url += " " + JSON.stringify(request.body);
    }
    const newError = new HttpErrorResponse({'error': error.error, 'headers': error.headers, 'status': error.status, 'statusText': error.statusText, 'url': url});
    return throwError(newError);
    }
}
